var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 55,
    viewBox: "0 0 34 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0319 19.3V7.15997C26.4919 5.59997 27.9019 2.83999 28.4419 1.23999C28.6419 0.63999 28.2419 0 27.6719 0H17.0619V7.16998V19.57L16.9219 29.91H29.4219C30.0019 29.91 30.4719 29.42 30.4319 28.84C30.2619 26.58 29.1919 21.36 23.0219 19.3H23.0319Z",
    fill: "#FFC000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.45312 46.61C7.45312 44.6 11.7631 42.96 17.0831 42.96C22.4031 42.96 26.7131 44.59 26.7131 46.61C26.7131 48.63 22.4031 50.2599 17.0831 50.2599C11.7631 50.2599 7.45312 48.63 7.45312 46.61Z",
    fill: "#FFC000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9023 18.4201V7.12012",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0934 7.11963C8.43341 7.11963 7.52344 1.09961 7.52344 1.09961H12.9934",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8635 19.0596C3.07346 21.4796 3.54345 29.9095 3.54345 29.9095H16.9335",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0938 29.9102V46.3302",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3117 41.2095C28.5317 42.0795 32.9917 44.4395 32.9917 47.2095C32.9917 50.7195 25.8317 53.5695 17.0017 53.5695C8.17171 53.5695 1.01172 50.7195 1.01172 47.2095C1.01172 44.1995 6.28171 41.6795 13.3417 41.0195",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0314 19.3V7.15997C26.4914 5.59997 27.9014 2.83999 28.4414 1.23999C28.6414 0.63999 28.2414 0 27.6714 0H20.1914V29.92H29.4214C30.0014 29.92 30.4714 29.43 30.4314 28.85C30.2614 26.59 29.1914 21.37 23.0214 19.31L23.0314 19.3Z",
    fill: "#0098C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.552698c4c8c1cb342515eea0e2a6ec36.svg";
export { ForwardRef as ReactComponent };